import * as React from 'react';

const QrCode24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.5 13c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6c-.83 0-1.5-.67-1.5-1.5v-6c0-.83.67-1.5 1.5-1.5zm6.5 6v3h-3v-3zm6 3h-3v-3h3zM3.5 20.5h6v-6h-6zm3-4.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m9.5 0h3v-3h3v3h-3v3h-3zh-3v-3h3zM9.5 2c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6C2.67 11 2 10.33 2 9.5v-6C2 2.67 2.67 2 3.5 2zm11 0c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6c-.83 0-1.5-.67-1.5-1.5v-6c0-.83.67-1.5 1.5-1.5zm-17 7.5h6v-6h-6zm11 0h6v-6h-6zM6.5 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  }
));
QrCode24.Size = 24;
QrCode24.Title = "QrCode";

export { QrCode24 as default };
